require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-5-iloq-6-im-m-5-yp-u-01-j-dbxoso.json") })
        }
      }, "path---news-c-5-iloq-6-im-m-5-yp-u-01-j-dbxoso");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-5-iloq-6-im-m-5-yp-u-01-j-dbxoso!./.cache/json/news-c-5-iloq-6-im-m-5-yp-u-01-j-dbxoso.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-5-iloq-6-im-m-5-yp-u-01-j-dbxoso!./.cache/json/news-c-5-iloq-6-im-m-5-yp-u-01-j-dbxoso.json
// module chunks = 231608221292675